import React from "react";
import {Helmet} from "react-helmet-async";
import EasLanding from "./EasLanding";
import CookieBanner from "../components/eas/CookieBanner";

/**
 * REPLACES the existing HomePage at "/". The previous Home component is no
 * longer used — delete src/components/home/Home.tsx after switching the route.
 *
 * SEO note: title/description tuned for "for parents · UK & US" positioning.
 * If you run multilingual, keep this canonical for /en/ only.
 */
export default function HomePage(): JSX.Element {
    return (
        <>
            <Helmet>
                <title>Effective Action System — for teenagers who want their own life</title>
                <meta
                    name="description"
                    content="A six-week operating system for ambitious teenagers. Built in Poland, refined with 950+ teens, now open internationally."
                />
                <link rel="canonical" href="https://effectiveactionsystem.com/"/>
                <meta property="og:title" content="Effective Action System"/>
                <meta property="og:description" content="A six-week operating system for ambitious teenagers."/>
                <meta property="og:url" content="https://effectiveactionsystem.com/"/>
                <meta property="og:type" content="website"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>
            <EasLanding/>
            <CookieBanner/>
        </>
    );
}
